/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ChatActionType = {
    LoadContactSupport: 'LOAD_CONTACT_SUPPORT',
    LoadCustomerAcceptDriver: 'LOAD_CUSTOMER_ACCEPT_DRIVER',
    LoadCustomerDeclineDriver: 'LOAD_CUSTOMER_DECLINE_DRIVER',
    LoadCustomerPickupGoodToGo: 'LOAD_CUSTOMER_PICKUP_GOOD_TO_GO',
    LoadCustomerStopGoodToGo: 'LOAD_CUSTOMER_STOP_GOOD_TO_GO',
    LoadCustomerDelivered: 'LOAD_CUSTOMER_DELIVERED',
    LoadDriverCancelConfirm: 'LOAD_DRIVER_CANCEL_CONFIRM',
    LoadDriverAcceptAgain: 'LOAD_DRIVER_ACCEPT_AGAIN',
    LoadDriverLeftStop: 'LOAD_DRIVER_LEFT_STOP',
    LoadDriverPaymentReceived: 'LOAD_DRIVER_PAYMENT_RECEIVED',
    LoadDriverOnRouteToStop: 'LOAD_DRIVER_ON_ROUTE_TO_STOP',
    LoadDriverStopArrived: 'LOAD_DRIVER_STOP_ARRIVED',
    LoadDriverRouteChangeAccept: 'LOAD_DRIVER_ROUTE_CHANGE_ACCEPT',
    LoadDriverRouteChangeDecline: 'LOAD_DRIVER_ROUTE_CHANGE_DECLINE'
} as const;
export type ChatActionType = typeof ChatActionType[keyof typeof ChatActionType];

